'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = null,
        classList = this.compileStyle(_index2.default);

    if (this.props.label) {
        label = _react2.default.createElement(
            'div',
            { className: classList.description },
            this.props.label
        );
    }

    var _props = this.props,
        disabled = _props.disabled,
        id = _props.id,
        name = _props.name,
        checked = _props.checked,
        value = _props.value,
        onChange = _props.onChange,
        attribute = _props.attribute;


    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        label,
        _react2.default.createElement(
            'div',
            { className: classList.labelWrapper },
            _react2.default.createElement('input', {
                disabled: disabled,
                name: name,
                checked: !!checked,
                value: value,
                type: 'radio',
                className: classList.field,
                ref: this._createRef.bind(this),
                onChange: onChange,
                id: id || this.state.id,
                'data-qa-node': attribute,
                'data-qa-value': value
            }),
            _react2.default.createElement(
                'label',
                { className: classList.label, htmlFor: id || this.state.id },
                _react2.default.createElement(
                    'div',
                    { className: classList.iconWrapper },
                    _react2.default.createElement('div', { className: classList.icon })
                ),
                _react2.default.createElement(
                    'div',
                    { className: classList.labelText },
                    this.props.children
                )
            )
        )
    );
}